(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-header-split"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.gh-mobile-toggle');
  const overlay = document.querySelector('.gh-mobile-overlay');

  if (toggle && overlay) {
    toggle.addEventListener('click', function () {
      overlay.classList.toggle('is-open');
      toggle.classList.toggle('is-active');

      document.body.classList.toggle('gh-mobile-menu-open');
    });
  }
});

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
  }

  connectedCallback() {
    this.isHome = this.classList.contains('gh-header-home');

    this.onScrollHandler = this.onScroll.bind(this);

    if (!this.isHome) {
      this.classList.remove('gh-header-hidden');
    }

    this.currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (!this.isHome) {
      this.classList.remove('gh-header-hidden');
      return;
    }

    if (scrollTop <= 10) {
      this.classList.add('gh-header-hidden');
    } else if (scrollTop < this.currentScrollTop) {
      this.classList.remove('gh-header-hidden');
    } else {
      this.classList.add('gh-header-hidden');
    }

    this.currentScrollTop = scrollTop;
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-principals"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
  }

  connectedCallback() {
    this.stickyType = this.getAttribute('data-sticky-type');

    if (this.stickyType === 'none') return;

    if (this.classList.contains('gh-header-home')) {
      this.classList.add('gh-header-hidden');
    } else {
      this.classList.add('gh-header-visible');
    }

    window.addEventListener('scroll', this.onScroll.bind(this), false);
  }

  onScroll() {
    if (this.classList.contains('gh-header-inner')) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= 10) {
      this.classList.remove('gh-header-hidden');
      this.classList.add('gh-header-visible');
    } else if (scrollTop > this.currentScrollTop) {
      this.classList.add('gh-header-hidden');
      this.classList.remove('gh-header-visible');
    } else if (scrollTop < this.currentScrollTop) {
      this.classList.remove('gh-header-hidden');
      this.classList.add('gh-header-visible');
    }

    this.currentScrollTop = Math.max(scrollTop, 0);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always';

    this.headerBounds = {};

    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.headerIsAlwaysSticky) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      requestAnimationFrame(this.hide.bind(this));

    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      requestAnimationFrame(this.reveal.bind(this));

    } else if (scrollTop <= this.headerBounds.top) {

      requestAnimationFrame(this.reset.bind(this));

    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
  }

  reveal() {
    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
